<template>
  <b-modal
    :id="`modal-reset-email-admin`"
    centered
    :title="`重設${role}:${resetData.name_cn}的電郵`"
    hide-footer
  >
    <b-card no-body>
      <!-- form -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form
            class="auth-form"
            @submit.prevent="handleSubmit(resetEmailForm)"
          >
            <validation-provider
              #default="{ errors }"
              name="此欄"
              rules="required|email"
            >
              <b-form-group class="required" label="電郵：">
                  <b-form-input
                    id="forgot-password-email"
                    v-model="newResetData.email"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="輸入電郵"
                  />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <div>
              <b-button type="submit" variant="primary" block class="">
                提交
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BLink,
  BOverlay,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ref, watch } from "@vue/composition-api";

import axiosIns from "@/libs/axios";

export default {
  components: {
    VuexyLogo,
    BModal,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    resetData: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
    };
  },
  computed: {
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-reset-email-admin");
    },
    resetEmailForm() {
      this.loading = true;
      axiosIns
        .post(`${this.url}`, this.newResetData)
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          this.hide();
          this.$emit("reset-data");
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$swal({
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    sendVertificationCode() {
      this.loading = true;
      axiosIns
        .post("/sendVertificationCode", { email: this.newResetData.email })
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$swal({
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
  },
  setup(props) {
    const newResetData = ref({});
    const loading = ref(false);

    watch(
      () => props.resetData,
      (newVal) => {
        newResetData.value = { ...newVal };
      }
    );

    const resetInvoiceData = () => {
      newResetData.value = {id:0};
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetInvoiceData);

    return {
      newResetData,
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
#forgot-password-email {
  border-radius: 0.357rem 0 0 0.357rem;
}
.auth-form {
  label {
    font-size: 14px;
  }
}
.input-group-text {
  padding: 0rem 0.5rem;
}
</style>
